import React from "react"
import {TransitionGroup,Transition as ReactTransition} from "react-transition-group"

const timeout = 300
const getTransitionStyles = {
  entering: {
    position: `absolute`,
    transform: `translate(0,40px)`,
    opacity: 0,
  },
  entered: {
    transition: `all 1500ms ease-in-out`,
    transform: `translate(0,0px)`,
    opacity: 1,
  },
  exiting: {
    transition: `all 200ms ease-in`,
    opacity: 0,
  },
}

class Transition extends React.PureComponent {
  render() {
    const { children, location } = this.props
    return (
      <TransitionGroup>
        <ReactTransition key={location.pathname} timeout={{enter: timeout, exit: timeout}}>
          {status => (
            <div className="childrencontent" style={{...getTransitionStyles[status]}}>
              {children}
            </div> )}
        </ReactTransition>
      </TransitionGroup>
    )
  }
}

export default Transition